import { render, staticRenderFns } from "./AdminDetailHistory.vue?vue&type=template&id=58129f7c"
import script from "./AdminDetailHistory.vue?vue&type=script&lang=js"
export * from "./AdminDetailHistory.vue?vue&type=script&lang=js"
import style0 from "./AdminDetailHistory.vue?vue&type=style&index=0&id=58129f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports